var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=container.escapeExpression, alias2=container.lambda;

  return "<li data-role=\"step-metadata\" class=\"step-container\" data-tab=\""
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : {},{"name":"id","hash":{},"data":data}) : helper)))
    + "\"\n    data-resourceRepresentationType=\""
    + alias1(alias2(((stack1 = ((stack1 = (depth0 != null ? depth0.metadata : depth0)) != null ? stack1.meContent : stack1)) != null ? stack1.resourceRepresentationType : stack1), depth0))
    + "\">\n    <span class=\"step-icon fx-background-color-primary-color icojam_box\"></span>\n    <h6 class=\"truncate step-title\">"
    + alias1(alias2(((stack1 = (depth0 != null ? depth0.labels : depth0)) != null ? stack1.title : stack1), depth0))
    + "</h6>\n</li>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/html/steps/step-metadata.hbs
// module id = 41
// module chunks = 0